<script setup lang="ts">
    import CanvasContainer from '@/components/CanvasContainer.vue';
    import TopBar from '@/components/TopBar.vue';
    import BaseButton from '@/components/BaseButton.vue';
    import FabricCanvasContainer from '@/components/FabricCanvasContainer.vue';
    import ContextMenu from '@/components/ContextMenu.vue';
    import FabricProductCanvasContainer from '@/components/FabricProductCanvasContainer.vue';
    import FormatSelection from '@/components/FormatSelection.vue';
    import { EProductFormat } from '@/typescript/enums/EProductFormat';
    import { useProductHas3d } from '@/composables/useProductHas3d';
    import { useConfigStore } from '@/store/config.store';
    import { useTemplateStore } from '@/store/template.store';
    import { putTemplate } from '@/api/template.api';
    import { Events } from '@/services/Events';
    import { t } from '@/translations/i18n';
    import { storeToRefs } from 'pinia';

    const { productHas3DModel } = useProductHas3d();

    const { currentSide, isAdmin, isProductEdition, productFormat } = storeToRefs(useConfigStore());

    const { selectedTemplate } = storeToRefs(useTemplateStore());

    async function save() {
        try {
            await putTemplate(selectedTemplate.value);
            Events.emit('call-toaster', { title: t('save_success'), type: 'success' });
        } catch (e) {
            Events.emit('call-toaster', { title: t('error_title'), body: `${e}`, type: 'error' });
        }
    }
</script>
<template>
    <div class="flex h-screen w-screen flex-col">
        <TopBar />
        <div
            v-if="!productHas3DModel"
            class="relative flex h-full w-full grow overflow-hidden"
        >
            <FormatSelection v-if="productFormat === EProductFormat.RECTO_VERSO" />
            <FabricProductCanvasContainer
                class="absolute w-full"
                :class="[currentSide === 'recto' && 'z-0', currentSide === 'verso' && 'z-[-1]']"
                :format="'recto'"
            />
            <FabricProductCanvasContainer
                v-if="productFormat === EProductFormat.RECTO_VERSO"
                class="absolute w-full"
                :class="[currentSide === 'verso' && 'z-0', currentSide === 'recto' && 'z-[-1]']"
                :format="'verso'"
            />
            <ContextMenu />
        </div>
        <div
            v-if="productHas3DModel"
            class="flex w-full grow flex-row gap-4"
        >
            <FabricCanvasContainer />
            <CanvasContainer class="w-1/3" />
            <ContextMenu />
        </div>
        <BaseButton
            v-if="isAdmin && !isProductEdition"
            class="fixed bottom-[45px] right-24 px-2"
            :label="$t('save')"
            @click="save"
        >
            {{ $t('save') }}
        </BaseButton>
    </div>
</template>
